(function(document) {
	'use strict';

/* -- Variables -- */

	let highlights, annotations, notes, comments;
	let timeoutID;
	let previousScroll;
	// const em = 16;
	const classActive = 'active';


/* -- Tools -- */

	function analytics(action) {
		dataLayer.push({
			'event': 'Interactive',
			'category': 'Interactive',
			'action': action,
			'label': 'null'
		});
		// console.clear();
		// console.table(dataLayer);
	}

	function throttle(callback, limit) {
		var wait = false;
		return function() {
			if (wait) return;
			callback.call();
			wait = true;
			setTimeout(function(){
				wait = false;
			}, limit);
		}
	}

	// function getOffsetTop(element) {
	// 	let offsetTop = 0;
	// 	// while(element && !isNaN(element.offsetTop)) {
	// 	// 	offsetTop += element.offsetTop - element.scrollTop;
	// 	// 	element = element.offsetParent;
	// 	// }
	// 	do { offsetTop += element.offsetTop; } while (element = element.offsetParent);
	// 	return offsetTop;
	// 	// return element.getBoundingClientRect().top + window.scrollY;
	// }

/* -- Function -- */

	function revealAnnotation(annotation) {
		// If the annotation is already open we return
		if (annotation.classList.contains(classActive)) return;

		// Hide all the other annotation
		annotations.forEach(x => hideAnnotation(x));

		// Reveal the annotation
		annotation.classList.add(classActive);
	}

	function hideAnnotation(annotation) {
		if (!annotation.classList.contains(classActive)) return;
		annotation.classList.remove(classActive);
	}

	// function checkLimits(top) {
	// 	const up = window.innerHeight * .2;
	// 	if (top<up) return up;

	// 	const down = window.innerHeight * .5;
	// 	if (top>down) return down;

	// 	return top;
	// }

	// function postionAnnotation(annotation, highlight) {
	// 	let top = '';
	// 	let right = '2.5vw';
	// 	// let left = '2.5vw';

	// 	// Fixed at the bottom of the page if they are on small screens
	// 	if (window.innerWidth > 600) {
	// 		// const highlightTop = highlight.getBoundingClientRect().top;
	// 		// top = highlightTop + getScrollTop() - 3*em + 'px';
	// 		// left = (contentPos.width - annotationPos.width)/2 + contentPos.left + 'px';

	// 		top = highlight.getBoundingClientRect().top;
	// 		// top = getOffsetTop(highlight);

	// 		// Make the box a bit higher
	// 		top = checkLimits(top) - 3*em + 'px';
	// 	}

	// 	annotation.style.top = top;
	// 	annotation.style.right = right;
	// 	// annotation.style.left = left;
	// }

	function displayAnnotation(highlight, type='click') {
		const id = highlight.classList[1];
		const annotation = document.getElementById(id);

		// Position the annotation
		// postionAnnotation(annotation, highlight);

		// If the user click, we reveal the annotation right away
		// otherwise we wait a second.
		const timeout = type === 'click' ? 0 : 300;

		// Reveal the annotation
		timeoutID = window.setTimeout(() => {
			revealAnnotation(annotation);
			analytics(`annotation-${type}`);
		}, timeout);
	}

	function interactHighlight(highlight) {
		// If the user only mouseover
		highlight.addEventListener('mouseover', event => {
			displayAnnotation(event.target, 'show');
		});

		// If the user mouseout, clean the timer
		highlight.addEventListener('mouseleave', () => {
			window.clearTimeout(timeoutID);
		});

		// If the user click on the highlight
		highlight.addEventListener('click', event => {
			event.preventDefault();
			window.clearTimeout(timeoutID);
			displayAnnotation(event.target);
		});
	}

	function interactAnnotation(annotation) {
		// Leave the annotation
		// annotation.addEventListener('mouseleave', event => {
		// 	timeoutID = window.setTimeout(() => hideAnnotation(event.target), 1000);
		// });

		annotation.addEventListener('mouseenter', () => window.clearTimeout(timeoutID));

		// Click on the close button
		annotation.querySelector('.bi_close').addEventListener('click', event => {
			hideAnnotation(event.target.parentElement);
		});
	}

	function limitLenghtOf(notes) {
		const s = ' ';
		const copy = notes.textContent.split(s);

		// Only for text longer than 15 words
		if (copy.length < 15) return;

		// Add an ellispsis in between the first and last 6 words
		notes.textContent = copy.slice(0,6).join(s)+' [...] '+copy.slice(-6).join(s);
	}

	function shorten(comment) {
		// If there is only one, we do nothing
		if (comment.textContent.length < 400) return;

		comment.classList.add('shorten');
		comment.addEventListener('click', function(){
			this.classList.remove('shorten');
		});
	}

	function scrollPast() {
		// Double check the value
		previousScroll = previousScroll === undefined ? 0 : previousScroll;

		// Check how much scroll we perfromed
		const delta = Math.abs(window.scrollY - previousScroll);

		// If we did more than half the page
		if (window.innerWidth > 600 && delta > window.innerHeight*2) {
			// Reset previousScroll
			previousScroll = window.scrollY;

			// Hide all annotations
			annotations.forEach(x => hideAnnotation(x));
		}
	}

/* -- Application -- */

	function app() {
		// Add the interaction on the hightlighted text
		highlights = [].slice.call(document.querySelectorAll('[class*=bia]')); //.post-body p .bi_notes
		highlights.forEach(x => interactHighlight(x));

		// Add the interaction on the annotation
		annotations = [].slice.call(document.querySelectorAll('.bi_annotation'));
		annotations.forEach(x => interactAnnotation(x));

		// Shorten the highlight and comments on the annotation
		notes = [].slice.call(document.querySelectorAll('.bi_annotation .bi_notes'));
		notes.forEach(x => limitLenghtOf(x));
		comments = [].slice.call(document.querySelectorAll('.bi_annotation .bi_author p'));
		comments.forEach(x => shorten(x));

		// Hide notatation if we go to far
		window.addEventListener('scroll', throttle(scrollPast, 200));

		// Remove explanation of the first hightlight if we do what we are told
		const firstHighlight = document.querySelector('.firstHighlight');
		if (firstHighlight !== null){
			firstHighlight.addEventListener('click', (e)=> e.target.classList.remove('firstHighlight'), false);
			firstHighlight.addEventListener('mouseover', (e)=> e.target.classList.remove('firstHighlight'), false);
		}
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'interactive' && !document.body.classList.contains('postid-471506') && app();
	}, false);

// end of the interactive
})(document);
